<template>
  <div class="page-container">
    <a-row type="flex">
      <a-col flex="280px">
        <div class="flex-between" style="margin-bottom: 10px">
          <span class="title-2">教师成长</span>
          <a-button type="primary" size="small" @click="createLeague">创建课题</a-button>
        </div>
        <div class="collapse">
          <a-collapse v-model="activeKey">
            <a-collapse-panel
              v-for="item in collapseList"
              :key="item.key"
              :header="item.header"
              style="background-color: #eff2f5; cursor: pointer"
            >
              <div
                v-for="child in item.children"
                :key="child.key"
                style="padding-left: 24px; color: #258ae9"
                @click="selectItem(child.key)"
              >
                {{ child.header }}
              </div>
            </a-collapse-panel>
          </a-collapse>
        </div>
      </a-col>
      <a-col flex="2px">
        <a-divider type="vertical" style="height: 700px" />
      </a-col>
      <a-col flex="auto">auto</a-col>
    </a-row>
    <CreateSubjectModal ref="createSubjectModalRef" />
  </div>
</template>

<script>
import CreateSubjectModal from '@/comUi/CreateSubjectModal'
export default {
  name: 'TeacherGrowth',
  components: {
    CreateSubjectModal,
  },
  data() {
    return {
      defaultSelectedKeys: ['0'],
      text: `A dog is a type of domesticated animal.Known for its loyalty and faithfulness,it can be found as a welcome guest in many households across the world.`,
      collapseList: [
        {
          header: '学校心理健康工作手册',
          key: '1',
          children: [
            {
              header: '手册使用说明',
              key: '七年级1班',
            },
          ],
        },
        {
          header: '咨询技术方法',
          key: '2',
          children: [
            {
              header: '技术方法使用说明',
              key: '2-1',
            },
          ],
        },
        {
          header: '课题研究方法指导',
          key: '3',
          children: [
            {
              header: '课题研究说明',
              key: '3-1',
            },
          ],
        },
      ],
      activeKey: ['1'],
    }
  },
  created() {
    this.getOpenKeys()
  },
  methods: {
    getOpenKeys() {
      this.activeKey = this.collapseList.map((item) => item.key)
    },
    selectItem(keys) {
      console.log('Trigger Select', keys)
    },
    onExpand() {
      console.log('Trigger Expand')
    },
    createLeague() {
      this.$refs.createSubjectModalRef.showModal()
    },
  },
}
</script>
<style scoped lang="less">
.collapse {
  /deep/ .ant-collapse {
    border: 1px solid #eef7ff;
  }
}
</style>
